import React from 'react';

/**
 * Optimized lazy-loading image component for PageSpeed
 * - Lazy loads images below the fold
 * - Provides proper accessibility attributes
 * - Supports responsive images
 */
const LazyImage = ({ 
  src, 
  alt, 
  className = '', 
  loading = 'lazy',
  decoding = 'async',
  ...props 
}) => {
  return (
    <img
      src={src}
      alt={alt}
      loading={loading}
      decoding={decoding}
      className={className}
      {...props}
    />
  );
};

export default LazyImage;
